'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { List, Record } from 'immutable';
import { LinkedInLocaleToFormLocale } from 'AdsUI/lib/LeadFormLocale';
import { Networks } from 'AdsUI/lib/Constants';
const PLACEHOLDER_LOCALE_BY_NETWORK = {
  [Networks.FACEBOOK]: 'EN_US',
  [Networks.LINKEDIN]: 'en_US'
};
export const ContextCardStyles = {
  PARAGRAPH_STYLE: 'PARAGRAPH_STYLE',
  LIST_STYLE: 'LIST_STYLE'
};
export const HiddenFieldRecord = Record({
  key: null,
  value: '',

  toNetwork() {
    return {
      key: this.key,
      label: this.value,
      format: 'TEXT',
      hidden: true,
      networkDefault: false
    };
  }

});
export class ContextCardRecord extends Record({
  title: null,
  content: null,
  style: null
}) {
  constructor({
    title,
    content,
    style
  }) {
    super({
      title,
      content: content ? List(content) : List(),
      style
    });
  }

}

class LeadFormRecord extends Record({
  leadFormFields: null,
  name: null,
  ownerId: null,
  formId: null,
  hubSpotFormId: null,
  adNetwork: null,
  websiteUrl: null,
  privacyPolicyUrl: null,
  consentHeadline: null,
  consentBody: null,
  thankYouBody: null,
  thankYouHeadline: null,
  networkLocale: null,
  thankYouCta: null,
  contextCard: null,
  description: null,
  headline: null,
  formErrorCount: null
}) {
  constructor(_ref) {
    let {
      contextCard
    } = _ref,
        form = _objectWithoutPropertiesLoose(_ref, ["contextCard"]);

    super(Object.assign({}, form, {
      contextCard: contextCard ? new ContextCardRecord(contextCard) : null
    }));
  }

  static getDemoData(network) {
    return [{
      consentBody: null,
      consentHeadline: null,
      networkLocale: PLACEHOLDER_LOCALE_BY_NETWORK[network],
      definition: {
        adNetwork: network,
        formId: '-1',
        ownerId: '-2',
        name: 'Biglytics Form',
        leadFormFields: [{
          key: 'email',
          label: 'Email',
          format: 'TEXT',
          networkDefault: true
        }, {
          key: 'full_name',
          label: 'Full name',
          format: 'TEXT',
          networkDefault: true
        }]
      }
    }];
  }

  static fromFBLeadForm(_ref2) {
    let {
      definition
    } = _ref2,
        form = _objectWithoutPropertiesLoose(_ref2, ["definition"]);

    return new LeadFormRecord(Object.assign({}, form, {}, definition, {
      networkLocale: form.networkLocale.toUpperCase()
    }));
  }

  static fromLILeadForm(_ref3) {
    let {
      definition,
      landingPageUrl
    } = _ref3,
        form = _objectWithoutPropertiesLoose(_ref3, ["definition", "landingPageUrl"]);

    return new LeadFormRecord(Object.assign({}, form, {}, definition, {
      websiteUrl: landingPageUrl,
      networkLocale: LinkedInLocaleToFormLocale[form.networkLocale]
    }));
  }

  static fromNetworkLeadForm(network, form) {
    switch (network) {
      case Networks.FACEBOOK:
        {
          return LeadFormRecord.fromFBLeadForm(form);
        }

      case Networks.LINKEDIN:
        {
          return LeadFormRecord.fromLILeadForm(form);
        }

      default:
        {
          throw new Error(`Can't parse forms from network ${network}`);
        }
    }
  }

  static fromCreationRequest(formId, creationRequest) {
    const {
      contextCard
    } = creationRequest,
          form = _objectWithoutPropertiesLoose(creationRequest, ["contextCard"]);

    return new LeadFormRecord(Object.assign({
      formId,
      contextCard: contextCard && new ContextCardRecord(contextCard)
    }, form));
  }

  get hasCustomConsent() {
    return !!this.consentHeadline;
  }

}

export default LeadFormRecord;